<template>
    <div v-if="signers.length">
        <CRow class="mb-3">
            <CCol col="3" tag="label" class="col-form-label">Подписанты</CCol>
            <CCol col="9" class="pl-1">
                <CRow
                    v-for="(signer, index) of signers"
                    :key="index"
                >
                    <CRow class="mb-2 ml-2">
                        <CCol>
                            <p>
                                {{ `${signer.position} ${signer.legal_entity} ${signer.name}` }}
                            </p>
                        </CCol>
                    </CRow>
                </CRow>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    export default {
        props: {
            signers: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
